import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 7 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_TaxFormEDIReport = _resolveComponent("TaxFormEDIReport")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "pa-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "9" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_back, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
            }),
            (_ctx.MenuOptions.zoomButtons.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 0,
                  icon: "$oss-zoom-out",
                  disabled: _ctx.MenuOptions.zoomButtons.isZoomOutDisabled,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.zoomOut()), ["stop"]))
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.zoomButtons.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 1,
                  icon: "$oss-focus",
                  disabled: _ctx.MenuOptions.zoomButtons.isResetZoomDisabled,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resetZoom()), ["stop"]))
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.zoomButtons.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 2,
                  icon: "$oss-zoom-in",
                  disabled: _ctx.MenuOptions.zoomButtons.isZoomInDisabled,
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.zoomIn()), ["stop"]))
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.OCRButtons.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 3,
                  icon: "$oss-eye",
                  disabled: _ctx.MenuOptions.OCRButtons.disabled,
                  loading: _ctx.MenuOptions.OCRButtons.isLoading,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.ocrChanged()), ["stop"]))
                }, null, 8, ["disabled", "loading"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.cutButton.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 4,
                  icon: "$fa-cut",
                  disabled: _ctx.MenuOptions.cutButton.disabled,
                  class: "ml-1",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.cut()), ["stop"]))
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.RotateDocument.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 5,
                  icon: "$fa-undo",
                  size: "x-small",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.rotateLeft()), ["stop"])),
                  disabled: _ctx.MenuOptions.RotateDocument.disabledLeftRotation
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.RotateDocument.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 6,
                  icon: "$fa-redo",
                  size: "x-small",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.rotateRight()), ["stop"])),
                  disabled: _ctx.MenuOptions.RotateDocument.disabledRightRotation
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.title.isDisplay)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.MenuOptions.title.text), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "3",
          class: "d-flex justify-end"
        }, {
          default: _withCtx(() => [
            (_ctx.MenuOptions.downloadButton.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 0,
                  icon: "$oss-download",
                  class: "mx-1",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.download())),
                  disabled: _ctx.MenuOptions.downloadButton.disabled
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (
                    _ctx.MenuOptions.editButton.isDisplay && _ctx.MenuOptions?.editButton?.HTMLMessage?.length
                )
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 1,
                  class: "pt-4 px-4",
                  location: "bottom"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                      _createVNode(_component_v_btn_icon, _mergeProps({
                        icon: "$oss-edit",
                        class: "mx-1",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.edit())),
                        disabled: _ctx.MenuOptions.editButton.disabled
                      }, props), null, 16, ["disabled"])
                    ], 16)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _ctx.MenuOptions.editButton.HTMLMessage
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }))
              : (_ctx.MenuOptions.editButton.isDisplay)
                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                    key: 2,
                    icon: "$oss-edit",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.edit())),
                    disabled: _ctx.MenuOptions.editButton.disabled
                  }, null, 8, ["disabled"]))
                : _createCommentVNode("", true),
            (_ctx.MenuOptions.displayModeButtons.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
                  key: 3,
                  modelValue: _ctx._displayMode,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx._displayMode) = $event)),
                  rounded: "xl",
                  class: "mt-1",
                  density: "compact",
                  divided: "",
                  variant: "outlined",
                  color: "secondary",
                  mandatory: ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.MenuOptions.displayModeButtons.isTableModeDisplay)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          value: 'table',
                          icon: "$fa-table",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.displayTable()))
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.MenuOptions.displayModeButtons.isAccountingLineModeDisplay)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          value: 'display-accounting-lines',
                          icon: "$fa-list",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.displayAccountingLine()))
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.MenuOptions.displayModeButtons.isPDFModeDisplay)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 2,
                          value: 'display-pdf',
                          icon: "$oss-file",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.displayFile())),
                          disabled: _ctx.MenuOptions.displayModeButtons.isPDFModeDisabled,
                          readonly: _ctx.MenuOptions.displayModeButtons.isPDFModeDisabled
                        }, null, 8, ["disabled", "readonly"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.duplicate.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 4,
                  rounded: "",
                  elevation: "0",
                  onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.duplicate()), ["stop"])),
                  size: "small",
                  class: "px-2 mt-2",
                  disabled: _ctx.MenuOptions.duplicate.disabled
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.duplicate.title), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.MenuOptions.dotMenu.isDisplay)
              ? (_openBlock(), _createBlock(_component_v_menu, {
                  key: 5,
                  "offset-y": ""
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      nav: "",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.MenuOptions.dotMenu.document.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.displayFile())),
                              disabled: _ctx.MenuOptions.dotMenu.document.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                                    _createTextVNode("$oss-file")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.document.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.accountingLine.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.displayAccountingLine())),
                              disabled: _ctx.MenuOptions.dotMenu.accountingLine.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                                    _createTextVNode("$oss-accounting-lines")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.accountingLine.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.items.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.displayItems())),
                              disabled: _ctx.MenuOptions.dotMenu.items.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                                    _createTextVNode("$oss-eye")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.items.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.download.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.download())),
                              disabled: _ctx.MenuOptions.dotMenu.download.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                                    _createTextVNode("$oss-download")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.download.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.upload.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 4,
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.upload())),
                              disabled: _ctx.MenuOptions.dotMenu.upload.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                                    _createTextVNode("$oss-upload")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.upload.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (
                            _ctx.MenuOptions.dotMenu.edit.isDisplay &&
                            _ctx.MenuOptions.dotMenu.edit.HTMLMessage.length
                        )
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 5,
                              class: "pt-4 px-4",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                  _createVNode(_component_v_btn_icon, _mergeProps({
                                    icon: "$oss-edit",
                                    class: "mx-1",
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.edit())),
                                    disabled: _ctx.MenuOptions.dotMenu.edit.disabled
                                  }, props), null, 16, ["disabled"])
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  innerHTML: _ctx.MenuOptions.dotMenu.edit.HTMLMessage
                                }, null, 8, _hoisted_3)
                              ]),
                              _: 1
                            }))
                          : (_ctx.MenuOptions.dotMenu.edit.isDisplay)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 6,
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.edit())),
                                disabled: _ctx.MenuOptions.dotMenu.edit.disabled
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "small" }, {
                                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                                      _createTextVNode("$oss-edit")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.edit.title), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.updateMTAE.isDisplay)
                          ? (_openBlock(), _createBlock(_component_TaxFormEDIReport, {
                              key: 7,
                              disabled: _ctx.MenuOptions.dotMenu.updateMTAE.disabled,
                              taxFormId: _ctx.MenuOptions.dotMenu.updateMTAE.taxformId,
                              isDeclaration: _ctx.MenuOptions.dotMenu.updateMTAE.isDeclaration
                            }, {
                              default: _withCtx(({ statusOk, mtaeProof }) => [
                                _createVNode(_component_v_list_item, {
                                  disabled: !statusOk,
                                  onClick: mtaeProof
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                                        _createTextVNode("$oss-download")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.updateMTAE.title), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ]),
                              _: 1
                            }, 8, ["disabled", "taxFormId", "isDeclaration"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.update.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 8,
                              disabled: _ctx.MenuOptions.dotMenu.update.disabled,
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.update()))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                                    _createTextVNode("$fa-redo-alt")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.update.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.regenerate.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 9,
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.regenerate())),
                              disabled: _ctx.MenuOptions.dotMenu.regenerate.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                                    _createTextVNode("$fa-redo-alt")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.regenerate.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.analyse.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 10,
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.analyse())),
                              disabled: _ctx.MenuOptions.dotMenu.analyse.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                                    _createTextVNode("$oss-scan")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.analyse.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.MenuOptions.dotMenu.activity.isDisplay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 11,
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.activity())),
                              disabled: _ctx.MenuOptions.dotMenu.activity.disabled
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                                    _createTextVNode("$oss-activity")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.activity.title), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_divider, { class: "pb-2" }),
                        (
                            _ctx.MenuOptions.dotMenu.delete.isDisplay &&
                            _ctx.MenuOptions.dotMenu.delete.HTMLMessage
                        )
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 12,
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                  _createVNode(_component_v_list_item, {
                                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.deleteDocument())),
                                    disabled: _ctx.MenuOptions.dotMenu.delete.disabled,
                                    color: "error",
                                    active: !_ctx.MenuOptions.dotMenu.delete.disabled
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[42] || (_cache[42] = [
                                          _createTextVNode("$oss-trash")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.delete.title), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "active"])
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  innerHTML: _ctx.MenuOptions.dotMenu.delete.HTMLMessage
                                }, null, 8, _hoisted_4)
                              ]),
                              _: 1
                            }))
                          : (_ctx.MenuOptions.dotMenu.delete.isDisplay)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 13,
                                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.deleteDocument())),
                                disabled: _ctx.MenuOptions.dotMenu.delete.disabled,
                                color: _ctx.MenuOptions.dotMenu.delete.disabled ? '' : 'error',
                                active: !_ctx.MenuOptions.dotMenu.delete.disabled
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "small" }, {
                                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                                      _createTextVNode("$oss-trash")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.MenuOptions.dotMenu.delete.title), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled", "color", "active"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_v_row, {
      "no-gutters": "",
      class: "px-2 pb-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            (_ctx.MenuOptions.isSelectedText)
              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                  key: 0,
                  modelValue: _ctx._selectedText,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx._selectedText) = $event)),
                  id: "selectedText",
                  "hide-details": "",
                  class: "ml-2 small-prepend-icon",
                  "append-inner-icon": "$oss-close",
                  "onClick:appendInner": _cache[30] || (_cache[30] = ($event: any) => (_ctx.clearSelectedText()))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx._selectedText]
    ])
  ], 64))
}